import React from 'react';
import { NavLink } from 'react-router-dom';

var img1 = require('./../../images/background/bg-4.png');
var img2 = require('./../../images/background/bg-site.png');

class OurValue3 extends React.Component {
    
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };

    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-gray bg-no-repeat bg-bottom-right mobile-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        <div className="section-content ">
                            <div className="row">
                                <div className="col-md-7 col-sm-6  m-b30">
                                    <div className="brochur bg-dark p-a20">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="p-a30 bg-primary bg-bottom-right" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                                    <div className="text-black">
                                                        <h4 className="mt-tilte m-t0">Your Takeoff Partner</h4>
                                                        <p>QTO International provides precise and efficient quantity takeoff solutions to help contractors manage projects with ease and accuracy. </p>
                                                        {/* <NavLink to="/project-detail" className="site-button-secondry btn-half"><span> Download brochure</span></NavLink> */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="text-white p-r15">
                                                    <h4 className="mt-tilte">Let Us Assist You!</h4>
                                                    <p>At QTO International, we specialize in providing accurate and reliable quantity takeoff services tailored to meet the needs of contractors worldwide.</p>
                                                    <NavLink to="/contactus" className="site-button btn-effect">Contact Us</NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5 col-sm-6 m-b30">
                                    <div className="our-exp">
                                        <div className="mt-box">
                                            
                                           <h3 className="m-t0"><span className="font-weight-100"> We have</span><span className="text-primary"> 9 years</span> experience in construction Estimation.</h3>
                                          
                                            <p><strong>With over 9 years of experience in construction estimation, we have successfully completed more than 3,000 projects, delivering precise and reliable takeoff services to contractors and clients. Our expertise spans a range of disciplines, including architectural, civil, structural, and MEP (Mechanical, Electrical, and Plumbing) estimation. Utilizing advanced technology and streamlined processes, we provide detailed and accurate cost assessments, ensuring our clients have the data they need to make informed decisions for project success.</strong></p>
                                        </div>
                                        {/* <span className="progressText text-black"><b>Architectural</b></span>
                                        <div className="progress mt-probar-1  m-b30 m-t10">
                                            <div className="progress-bar bg-primary " role="progressbar" aria-valuenow={85} aria-valuemin={0} aria-valuemax={100}>
                                                <span className="popOver" data-toggle="tooltips" data-placement="top" title="85%" />
                                            </div>
                                        </div>
                                        <span className="progressText text-black"><b>Construction</b></span>
                                        <div className="progress mt-probar-1 m-b30 m-t10">
                                            <div className="progress-bar bg-primary" role="progressbar" aria-valuenow={90} aria-valuemin={10} aria-valuemax={100}>
                                                <span className="popOver" data-toggle="tooltips" data-placement="top" title="90%" />
                                            </div>
                                        </div>
                                        <span className="progressText text-black"><b>Federal</b></span>
                                        <div className="progress mt-probar-1 m-b30 m-t10">
                                            <div className="progress-bar bg-primary" role="progressbar" aria-valuenow={95} aria-valuemin={0} aria-valuemax={100}>
                                                <span className="popOver" data-toggle="tooltips" data-placement="top" title="95%" />
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default OurValue3;